import readXlsxFile from 'read-excel-file'

const schema = {
  'ARTICLE': {
    prop: 'article',
    type: Number,
    required: true,
  },
  'AMOUNT': {
    prop: 'amount',
    type: Number,
    required: true,
  },
}

class Parse {

  parseFile (file) {

    return readXlsxFile(file, { schema }).
      then(({ errors, rows }) => rows).
      catch((error) => console.log(error))
  }

  parseText (data) {

    let textParts = data ? data.match( /\w+-\d+/gm ) : [];

    return textParts.map(item => {
      const dataArr = item.split('-')

      return {
        article: dataArr[0],
        amount: parseInt(dataArr[1]),
      }
    })
  }

}

export default new Parse()